import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cmsviewcourses',
  templateUrl: './cmsviewcourses.component.html',
  styleUrls: ['./cmsviewcourses.component.css']
})
export class CmsviewcoursesComponent implements OnInit {
  @Input() hideBlock: boolean = true;

  constructor(private router: Router) { }
  ngOnInit() {
  }

  viewCourses(page: string) {
    switch (page) {
      case 'one-to-one':
        this.router.navigate(['/one-to-one-live-classes']);
        break;
      case 'online-study-packages':
        this.router.navigate(['/package']);
        break;
      case 'juniorhacker':
        this.router.navigateByUrl('/juniorhacker');
        break;
      case 'sat':
        this.router.navigateByUrl('/sat');
        break;
      case 'tablet-learning-program':
        this.router.navigate(['/package']);
        break;
      default:
        break;
    }
  }
}
